<div
  *ngIf="domOpen"
  #overlayRoot
  class="v2-detail-overlay"
  [class.v2-detail-overlay--video]="viewMode === 'videoView'"
  [class.v2-detail-overlay--closing]="isClosing"
>
  <!-- Floating close (album / v3-dc pattern); in video view returns to sticker reels -->
  <button
    type="button"
    class="v2-do-close"
    (click)="onHeaderBack()"
    [attr.aria-label]="
      viewMode === 'videoView' ? ('VIDEO_BACK_TO_STICKER' | translate) : ('BUTTON_CLOSE' | translate)
    "
  >
    ×
  </button>

  <button
    *ngIf="showOpenAlbumButton && viewMode === 'slideView'"
    type="button"
    class="v2-detail-open-album-btn"
    (click)="onOpenAlbumClick()"
    [attr.aria-label]="'V2_DETAIL_OPEN_ALBUM' | translate"
  >
    <ion-icon name="albums-outline" aria-hidden="true"></ion-icon>
  </button>

  <!-- Top-center title pill (mirrors v2-album-overlay .v2-ao-title-pill); hidden in video for space -->
  <div
    *ngIf="sectionTitle && viewMode !== 'videoView'"
    class="v2-do-title-pill"
    aria-hidden="true"
  >
    {{ sectionTitle }}
  </div>

  <main
    #detailContentStage
    class="v2-detail-content"
    [class.v2-detail-content-stage]="viewMode === 'videoView'"
    [class.v2-detail-content--video]="viewMode === 'videoView'"
  >
    <!-- Slide view: flip card reels -->
    <div
      *ngIf="viewMode === 'slideView'"
      #detailSlideWrap
      class="v2-detail-slide-wrap"
      [class.v2-detail-slide-wrap--intro-pending]="detailSlideWrapIntroPending"
    >
      <div #v2ReelsRoot class="v2-reels-root">
        <div
          class="v2-reels-track"
          [style.transform]="trackTransform"
          [style.transition]="
            trackTransition ? 'transform 0.28s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none'
          "
          [style.height]="
            sectionItems.length > 0
              ? 'calc(' +
                sectionItems.length +
                ' * 100% + ' +
                (sectionItems.length - 1) +
                ' * ' +
                reelGap +
                'px)'
              : '100%'
          "
        >
          <div
            *ngFor="let item of sectionItems; let i = index; trackBy: trackBySectionItem"
            class="v2-reel"
            [style.height]="
              sectionItems.length > 0
                ? 'calc((100% - ' +
                  (sectionItems.length - 1) +
                  ' * 1rem) / ' +
                  sectionItems.length +
                  ')'
                : '100%'
            "
          >
            <div
              class="v2-detail-flip-card"
              [ngClass]="{
                'v2-detail-flip-card--landscape': isLandscapeOrientation(item),
                'v2-detail-flip-card--portrait': !isLandscapeOrientation(item)
              }"
            >
              <div
                class="v2-detail-flip-inner"
                [ngClass]="{ 'v2-detail-flip-no-anim': flipDragActive && i === currIndexInSection }"
                [style.transform]="i === currIndexInSection ? 'rotateY(' + flipRotationY + 'deg)' : null"
              >
                <!-- Front -->
                <div class="v2-detail-front">
                  <div
                    class="v2-detail-img-wrap"
                    [ngClass]="{
                      'v2-detail-img-wrap--landscape': isLandscapeOrientation(item),
                      'v2-detail-img-wrap--portrait': !isLandscapeOrientation(item),
                      'v2-detail-img-wrap--missing': !hasTenho(item)
                    }"
                  >
                    <div *ngIf="hasTenho(item)" class="v2-detail-img-inner">
                      <img
                        (load)="onFrontStickerImageLoad($event, item, i)"
                        (error)="onFrontStickerImageLoad($event, item, i)"
                        [attr.data-item-id]="item?.item_id"
                        class="v2-detail-img"
                        [ngClass]="{'v2-detail-img-fade': !getReelImageLoading(item)}"
                        [src]="getStickerUrl(item)"
                        alt=""
                      />
                      <div class="v2-detail-loader-wrap" *ngIf="getReelImageLoading(item)"></div>
                      <button
                        *ngIf="item?.video && showVideo"
                        type="button"
                        class="v2-detail-play-btn"
                        (click)="$event.stopPropagation(); onPlayVideo(i)"
                        aria-label="Play video"
                      >
                        <img
                          src="assets/icon/play-icon.svg"
                          alt=""
                          class="v2-detail-play-icon"
                          role="presentation"
                        />
                      </button>
                    </div>
                    <div *ngIf="!hasTenho(item)" class="v2-detail-img-inner v2-detail-img-inner--missing">
                      <img
                        (load)="onFrontStickerImageLoad($event, item, i)"
                        (error)="onFrontStickerImageLoad($event, item, i)"
                        [attr.data-item-id]="item?.item_id"
                        [src]="getStickerUrl(item)"
                        class="v2-detail-img v2-detail-img-missing"
                        [ngClass]="{'v2-detail-img-fade': !getReelImageLoading(item)}"
                        alt=""
                      />
                      <div class="v2-detail-loader-wrap" *ngIf="getReelImageLoading(item)"></div>
                      <div class="v2-detail-locked-overlay">
                        <div class="v2-detail-locked-icon-wrap">
                          <svg
                            class="v2-detail-locked-icon"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Back (portrait or missing) — same .v2-detail-img-wrap as front so faces match -->
                <div
                  *ngIf="showBackPortraitOrMissing(item)"
                  class="v2-detail-back"
                >
                  <div
                    class="v2-detail-img-wrap"
                    [ngClass]="{
                      'v2-detail-img-wrap--landscape': isLandscapeOrientation(item),
                      'v2-detail-img-wrap--portrait': !isLandscapeOrientation(item),
                      'v2-detail-img-wrap--missing': !hasTenho(item)
                    }"
                  >
                    <div class="v2-detail-back-sized" [ngStyle]="getBackSizedStyle(item)">
                    <div class="v2-detail-back-bg-wrap">
                      <img class="v2-detail-back-bg" src="./assets/images/back-img-vertical.svg" alt="" />
                    </div>
                  <div class="v2-detail-back-content">
                    <svg
                      class="v2-detail-back-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1920 1080"
                    >
                      <defs><style>.cls-title{fill:#000}</style></defs>
                      <g>
                        <path class="cls-title" d="M108.26,346.89h284.06v55.51h-223.82v106.3h189.57v55.51h-189.57v113.39h223.82v55.51H108.26v-386.23Z"/>
                        <path class="cls-title" d="M869.91,515.24c0-115.03,67.04-168.36,155.41-168.36,57.9,0,106.65,25.9,132.55,74.66,25.9-48.75,73.9-74.66,132.55-74.66,88.37,0,155.41,53.33,155.41,168.36v217.87h-72.37v-217.87c0-70.09-37.33-101.32-89.89-101.32s-89.13,32.76-89.13,101.32v217.87h-72.37v-217.87c0-68.56-38.85-101.32-89.89-101.32s-89.89,31.23-89.89,101.32v217.87h-72.37v-217.87Z"/>
                        <path class="cls-title" d="M1499.94,580.16c0-88.24,64.71-152.95,156.48-152.95s155.31,64.71,155.31,152.95v20.59h-252.96c8.24,51.77,47.06,80.6,97.66,80.6,37.65,0,64.12-11.77,81.18-37.06h61.77c-22.36,54.12-75.3,88.83-142.95,88.83-91.77,0-156.48-64.71-156.48-152.95ZM1752.91,550.75c-11.18-46.47-49.42-71.77-96.48-71.77s-84.71,25.88-95.89,71.77h192.37Z"/>
                        <polygon class="cls-title" points="663.99 580.29 663.99 427.21 815.66 427.21 663.99 580.29"/>
                        <polygon class="cls-title" points="446.5 427.21 599.42 580.13 446.43 733.11 511.16 733.11 663.99 580.29 510.9 427.21 446.5 427.21"/>
                        <polygon class="cls-title" points="663.99 580.29 663.99 733.11 815.66 733.11 663.99 580.29"/>
                      </g>
                    </svg>
                    <div class="v2-detail-back-id">{{ item?.item_id }}</div>
                    <ion-label class="v2-detail-back-label v2-detail-back-label-1">{{
                      collectionDetails?.collection_tag
                    }}</ion-label>
                    <ion-label class="v2-detail-back-label v2-detail-back-label-2">{{
                      item?.item_name
                    }}</ion-label>
                    <ion-label class="v2-detail-back-label v2-detail-back-label-3">{{
                      item?.section_name
                    }}</ion-label>
                    <div class="v2-detail-back-desc">
                      <quill-view
                        *ngIf="hasDescription(item?.description_1)"
                        [content]="item?.description_1"
                        format="json"
                        theme="bubble"
                      ></quill-view>
                      <quill-view
                        *ngIf="hasDescription(item?.description_2)"
                        [content]="item?.description_2"
                        format="json"
                        theme="bubble"
                      ></quill-view>
                    </div>
                  </div>
                    </div>
                  </div>
                </div>

                <!-- Back (landscape) — same .v2-detail-img-wrap as front -->
                <div
                  *ngIf="showBackLandscapeOwned(item)"
                  class="v2-detail-back"
                >
                  <div
                    class="v2-detail-img-wrap"
                    [ngClass]="{
                      'v2-detail-img-wrap--landscape': isLandscapeOrientation(item),
                      'v2-detail-img-wrap--portrait': !isLandscapeOrientation(item),
                      'v2-detail-img-wrap--missing': !hasTenho(item)
                    }"
                  >
                    <div class="v2-detail-back-sized" [ngStyle]="getBackSizedStyle(item)">
                    <div class="v2-detail-back-bg-wrap">
                      <img
                        class="v2-detail-back-bg"
                        src="./assets/images/back-img-horizontal.svg"
                        alt=""
                      />
                    </div>
                  <div class="v2-detail-back-content v2-detail-back-content--landscape">
                    <svg
                      class="v2-detail-back-svg v2-detail-back-svg--landscape"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1920 1080"
                    >
                      <defs><style>.cls-title{fill:#000}</style></defs>
                      <g>
                        <path class="cls-title" d="M108.26,346.89h284.06v55.51h-223.82v106.3h189.57v55.51h-189.57v113.39h223.82v55.51H108.26v-386.23Z"/>
                        <path class="cls-title" d="M869.91,515.24c0-115.03,67.04-168.36,155.41-168.36,57.9,0,106.65,25.9,132.55,74.66,25.9-48.75,73.9-74.66,132.55-74.66,88.37,0,155.41,53.33,155.41,168.36v217.87h-72.37v-217.87c0-70.09-37.33-101.32-89.89-101.32s-89.13,32.76-89.13,101.32v217.87h-72.37v-217.87c0-68.56-38.85-101.32-89.89-101.32s-89.89,31.23-89.89,101.32v217.87h-72.37v-217.87Z"/>
                        <path class="cls-title" d="M1499.94,580.16c0-88.24,64.71-152.95,156.48-152.95s155.31,64.71,155.31,152.95v20.59h-252.96c8.24,51.77,47.06,80.6,97.66,80.6,37.65,0,64.12-11.77,81.18-37.06h61.77c-22.36,54.12-75.3,88.83-142.95,88.83-91.77,0-156.48-64.71-156.48-152.95ZM1752.91,550.75c-11.18-46.47-49.42-71.77-96.48-71.77s-84.71,25.88-95.89,71.77h192.37Z"/>
                        <polygon class="cls-title" points="663.99 580.29 663.99 427.21 815.66 427.21 663.99 580.29"/>
                        <polygon class="cls-title" points="446.5 427.21 599.42 580.13 446.43 733.11 511.16 733.11 663.99 580.29 510.9 427.21 446.5 427.21"/>
                        <polygon class="cls-title" points="663.99 580.29 663.99 733.11 815.66 733.11 663.99 580.29"/>
                      </g>
                    </svg>
                    <div class="v2-detail-back-id">{{ item?.item_id }}</div>
                    <ion-label class="v2-detail-back-label v2-detail-back-label-1">{{
                      collectionDetails?.collection_tag
                    }}</ion-label>
                    <ion-label class="v2-detail-back-label v2-detail-back-label-2">{{
                      item?.item_name
                    }}</ion-label>
                    <ion-label class="v2-detail-back-label v2-detail-back-label-3">{{
                      item?.section_name
                    }}</ion-label>
                    <div class="v2-detail-back-desc v2-detail-back-desc--landscape">
                      <quill-view
                        *ngIf="hasDescription(item?.description_1)"
                        [content]="item?.description_1"
                        format="json"
                        theme="bubble"
                      ></quill-view>
                    </div>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!isMobile" class="v2-detail-reel-nav">
        <button
          type="button"
          class="v2-detail-chevron v2-detail-chevron--prev"
          (click)="changeSlide('B')"
          [attr.aria-label]="'V2_DETAIL_REEL_PREVIOUS_STICKER' | translate"
        >
          <ion-icon name="chevron-up-outline" aria-hidden="true"></ion-icon>
        </button>
        <button
          type="button"
          class="v2-detail-chevron v2-detail-chevron--flip"
          (click)="toggleFlipCard()"
          [attr.aria-label]="
            (flipRotationY < 90 ? 'V2_DETAIL_FLIP_SHOW_BACK' : 'V2_DETAIL_FLIP_SHOW_FRONT') | translate
          "
        >
          <ion-icon name="repeat-outline" aria-hidden="true"></ion-icon>
        </button>
        <button
          type="button"
          class="v2-detail-chevron v2-detail-chevron--next"
          (click)="changeSlide('F')"
          [attr.aria-label]="'V2_DETAIL_REEL_NEXT_STICKER' | translate"
        >
          <ion-icon name="chevron-down-outline" aria-hidden="true"></ion-icon>
        </button>
      </div>
    </div>

    <!-- Video view -->
    <div *ngIf="viewMode === 'videoView'" class="v2-detail-video-wrap">
      <div *ngIf="videoElementError" class="v2-detail-video-error" role="alert">
        <p class="v2-detail-video-error-text">{{ 'VIDEO_LOAD_ERROR' | translate }}</p>
        <button type="button" class="v2-detail-video-retry" (click)="retryInlineVideo()">
          {{ 'VIDEO_RETRY' | translate }}
        </button>
      </div>
      <div
        *ngIf="!inlineVideoReady && !videoElementError && videoSrc"
        class="v2-detail-video-loader"
      >
        <div class="loader"></div>
        <h1 class="v2-detail-video-loader-text">
          {{
            videoLoaderAltText ? ('VIDEO_LOADER_TEXT_2' | translate) : ('VIDEO_LOADER_TEXT_1' | translate)
          }}
        </h1>
      </div>
      <div *ngIf="videoSrc" #v2VideoStage class="v2-detail-video-stage" (click)="onVideoStageClick($event)">
        <video
          #v2VideoPlayer
          class="v2-detail-video"
          [class.v2-detail-video--landscape]="aspectRatio === 'LANDSCAPE'"
          [class.v2-detail-video--portrait]="aspectRatio === 'PORTRAIT'"
          [attr.aria-label]="videoAriaLabel"
          [title]="videoAriaLabel"
          preload="metadata"
          autoplay
          [muted]="videoMuted"
          playsinline
          controlsList="nodownload noplaybackrate"
          (loadedmetadata)="onVideoLoadedMetadata()"
          (timeupdate)="onVideoTimeUpdate()"
          (progress)="onVideoProgress()"
          (play)="onVideoPlayEvent()"
          (pause)="onVideoPauseEvent()"
          (playing)="onVideoPlayingEvent()"
          (canplay)="onV2VideoCanPlay()"
          (canplaythrough)="onVideoCanPlayThrough()"
          (error)="onV2VideoError()"
          (ended)="onVideoEnd()"
          [ngClass]="{ 'v2-detail-video-fade': inlineVideoReady || hasVideoLoaded }"
        >
          <source [src]="videoSrc" type="video/mp4" />
        </video>

        <div
          class="v2-detail-video-chrome"
          *ngIf="inlineVideoReady && !videoElementError"
          [class.v2-detail-video-chrome--hidden]="
            !videoChromeVisible && videoPlaying && !videoUnmuteHintShown
          "
          (click)="$event.stopPropagation()"
        >
          <button
            type="button"
            class="v2-detail-video-chrome__fab"
            [class.v2-detail-video-chrome__fab--visible]="!videoPlaying"
            (click)="toggleVideoPlay(); $event.stopPropagation()"
            [attr.aria-label]="'VIDEO_PLAY' | translate"
            [attr.aria-hidden]="videoPlaying"
            [attr.tabindex]="videoPlaying ? -1 : 0"
          >
            <ion-icon name="play" aria-hidden="true"></ion-icon>
          </button>

          <div class="v2-detail-video-chrome__panel">
            <div
              class="v2-detail-video-chrome__unmute-hint"
              *ngIf="videoUnmuteHintShown"
              role="status"
            >
              <span class="v2-detail-video-chrome__unmute-hint-text">{{ 'VIDEO_UNMUTE_HINT' | translate }}</span>
              <button
                type="button"
                class="v2-detail-video-chrome__unmute-hint-dismiss"
                (click)="dismissUnmuteHint($event)"
                [attr.aria-label]="'VIDEO_UNMUTE_HINT_DISMISS' | translate"
              >
                <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
              </button>
            </div>
            <div class="v2-detail-video-chrome__buffer-track" aria-hidden="true">
              <div
                class="v2-detail-video-chrome__buffer-fill"
                [style.width.%]="videoBufferedPercent"
              ></div>
            </div>
            <div class="v2-detail-video-chrome__controls">
              <button
                type="button"
                class="v2-detail-video-chrome__icon-btn"
                (click)="toggleVideoPlay(); $event.stopPropagation()"
                [attr.aria-label]="(videoPlaying ? 'VIDEO_PAUSE' : 'VIDEO_PLAY') | translate"
              >
                <ion-icon [name]="videoPlaying ? 'pause' : 'play'" aria-hidden="true"></ion-icon>
              </button>
              <span class="v2-detail-video-chrome__time"
                >{{ formatVideoTime(videoCurrentTime) }} / {{ formatVideoTime(videoDuration) }}</span
              >
              <span class="v2-detail-video-chrome__controls-spacer" aria-hidden="true"></span>
              <button
                type="button"
                class="v2-detail-video-chrome__icon-btn"
                (click)="toggleVideoMute(); $event.stopPropagation()"
                [attr.aria-label]="(videoMuted ? 'VIDEO_UNMUTE' : 'VIDEO_MUTE') | translate"
              >
                <ion-icon [name]="videoMuted ? 'volume-mute' : 'volume-high'" aria-hidden="true"></ion-icon>
              </button>
              <button
                type="button"
                class="v2-detail-video-chrome__icon-btn"
                (click)="toggleVideoFullscreen(); $event.stopPropagation()"
                [attr.aria-label]="(videoIsFullscreen ? 'VIDEO_EXIT_FULLSCREEN' : 'VIDEO_FULLSCREEN') | translate"
              >
                <ion-icon
                  [name]="videoIsFullscreen ? 'contract-outline' : 'expand-outline'"
                  aria-hidden="true"
                ></ion-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <p
    *ngIf="isMobile && viewMode === 'slideView' && isOpen"
    class="v2-detail-swipe-hint"
    [class.v2-detail-swipe-hint--stacked]="showFooter"
    [class.v2-detail-swipe-hint--hide]="!showSwipeHintMobile"
    aria-hidden="true"
  >
    <span class="v2-detail-swipe-hint__line">{{ 'V2_DETAIL_SWIPE_HINT_LINE1' | translate }}</span>
    <span class="v2-detail-swipe-hint__line">{{ 'V2_DETAIL_SWIPE_HINT_LINE2' | translate }}</span>
  </p>

  <!-- Footer: ORANGE morphs one wide SWAP into Request + Swap (slides away in video view) -->
  <footer
    class="v2-detail-footer"
    *ngIf="showFooter"
    [class.v2-detail-footer--video-mode]="viewMode === 'videoView'"
    [attr.aria-hidden]="viewMode === 'videoView' ? 'true' : null"
  >
    <div
      class="v2-detail-footer-inner"
      [class.opened]="footerChromeReveal"
      [class.loaded]="footerChromeReveal"
    >
      <!-- Always two app-btns: Request (hidden when no pending request) + Swap -->
      <div
        class="v2-detail-footer-actions"
        [ngClass]="{
          'v2-detail-footer-morph': iconColor === 'ORANGE',
          'v2-detail-footer-morph-reverse': iconColor !== 'ORANGE',
          'v2-detail-footer-morph-reverse--from-orange': footerMorphReverseFromOrange
        }"
      >
        <div class="v2-detail-footer-request-col">
          <app-btn
            class="v2-detail-footer-btn v2-detail-footer-btn--request"
            [class.v2-detail-morph-request]="iconColor === 'ORANGE'"
            [class.v2-detail-footer-btn--request-collapsed]="iconColor !== 'ORANGE'"
            [text]="'CHECK_REQUEST' | translate"
            icon="mail-open"
            type="primary"
            [attr.aria-hidden]="iconColor !== 'ORANGE' ? 'true' : null"
            (clicked)="onFooterRequestClick()"
          ></app-btn>
        </div>
        <div class="v2-detail-footer-swap-col">
          <app-btn
            class="v2-detail-footer-btn v2-detail-footer-btn--swap"
            [class.v2-detail-morph-swap]="iconColor === 'ORANGE'"
            [class.v2-detail-morph-swap-alone]="iconColor !== 'ORANGE'"
            [text]="'SWAP' | translate"
            icon="swap-horizontal-outline"
            type="primary"
            (clicked)="onFooterAction('exchangeBlue')"
          ></app-btn>
        </div>
      </div>
    </div>
  </footer>
</div>
